import {SettingsController} from './settings.controller';
import Auth from './tabs/authentication/authentication.module';
import DatabaseSync from './tabs/database_sync/database_sync.module';
import FailedArtifacts from './tabs/failed_artifacts/failed_artifacts.module';
import General from './tabs/general/general.module';
import Instances from './tabs/instances/instances.module';
import Integrations from './tabs/integrations/integrations.module';
import Mail from './tabs/mail/mail.module';
import Permissions from './tabs/permissions/permissions.module';
import Proxy from './tabs/proxy/proxy.module';
import SetLicense from './tabs/set_license/set_license.module';
import SystemLogs from './tabs/system_logs/system_logs.module';
import SystemLicenses from './tabs/system_licenses/system_licenses.module';
import HA from './tabs/ha/ha.module';
import Users from './tabs/users/users.module';
import Webhooks from './tabs/webhooks/webhooks.module';
import SystemMonitoring from './tabs/system_monitoring/system_monitoring.module';
import supportPageConfig from './tabs/support_page/support_page.module';
import httpConfig from './tabs/http_config/http_config.module';

function settingsConfig ($stateProvider) {

    $stateProvider
            .state('settings', {
                url: '/admin',
                parent: 'app-layout',
                params: {tab: 'random'},
                template: require('./settings.html'),
                controller: 'SettingsController as Settings'
            })

}


export default angular.module('settings', [
    General.name,
    Instances.name,
    DatabaseSync.name,
    Users.name,
    Mail.name,
    Webhooks.name,
    Integrations.name,
    SetLicense.name,
    Proxy.name,
    SystemLogs.name,
    Permissions.name,
    Auth.name,
    FailedArtifacts.name,
    HA.name,
    SystemMonitoring.name,
    supportPageConfig.name,
    httpConfig.name,
    SystemLicenses.name
])
.config(settingsConfig)
.controller('SettingsController', SettingsController)



// WEBPACK FOOTER //
// ./modules/xray/states/settings/settings.module.js